import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { STabs, STabList, STab, STabPanel } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import moment from "moment";
import { AdminTable } from "../../components/AdminTable";
import { addCategory, getCategoriesList, editCategory, deleteCategory } from "../../api/admin/categories";
import { addLabel, getLabelsList, editLabel, deleteLabel } from "../../api/admin/labels";
import { AdminSearchScore } from "../../components/AdminSearchScore";
import { SearchMappingAdmin } from "../../components/Admin/SearchMappingAdmin";
import useCurrentUser from "../../hooks/useCurrentUser";

export default function AdminPage() {
	const { isRoot, isOrgAdmin } = useCurrentUser();
	const currentRole = isRoot ? "root" : isOrgAdmin ? "admin" : null;


	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<h1>Admin panel</h1>
						<div>
							<i>
								<img src={CalendarIcon} alt="Date" />
							</i>
							<span>{`${moment(new Date()).format("YYYY-MM-DD")}`}</span>
						</div>
					</StyledPageHeader>
					<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
						<STabList>
							<STab>Categories</STab>
							<STab>Labels</STab>
							{currentRole === "root" && <STab>Search mapping</STab>}
							{currentRole === "root" && <STab>Decision mapping</STab>}
							{currentRole === "root" && <STab>User mapping</STab>}
						</STabList>
						<STabPanel>
							<AdminTable name={"Categories"} singularName={"category"} getFunc={(axios) => getCategoriesList(axios, currentRole !== "root")} addFunc={addCategory} editFunc={editCategory} deleteFunc={deleteCategory} />
						</STabPanel>
						<STabPanel>
							<AdminTable name={"Labels"} singularName={"label"} getFunc={(axios) => getLabelsList(axios, currentRole !== "root")} addFunc={addLabel} editFunc={editLabel} deleteFunc={deleteLabel} />
						</STabPanel>
						{currentRole === "root" && (
						<STabPanel>
							<SearchMappingAdmin />
						</STabPanel>
						)}
						{currentRole === "root" && (
						<STabPanel>
							<AdminSearchScore group="decision" />
						</STabPanel>
						)}
						{currentRole === "root" && (
						<STabPanel>
							<AdminSearchScore group="user" />
						</STabPanel>
						)}
					</STabs>
				</Col>
			</Row>
		</Container>
	);
}
